import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Main.module.scss";
import StateContext from "../../context/state";
import PathContext from "../../context/path";
import Footer from '../../components/Footer';
import Cover from '../../components/Cover';
import Header from '../../components/Header/Header';
import SpyMenu from '../../components/SpyMenu';
import Collapse from '../../components/Collapse';
import ItemList from '../../components/ItemList';
import Question from '../../components/Question';
import Table from '../../components/Table';
import Form from '../../components/Form';
const Main = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const refCoopBtn = useRef(null);
  const refCoop = useRef(null);
  const { updatePopupOpen, isMobile } = state;
  useEffect(() => {
    const coop = refCoop.current;
    const coopBtn = refCoopBtn.current;
    if (isMobile) return;
    const addHover = () => {
      coop.classList.add(styles.hover);
    }
    const removeHover = () => {
      coop.classList.remove(styles.hover);
    }
    coopBtn.addEventListener('mouseover', addHover);
    coopBtn.addEventListener('mouseout', removeHover);
    return () => {
      coop.classList.remove(styles.hover);
      coopBtn.removeEventListener('mouseover', addHover);
      coopBtn.removeEventListener('mouseout', removeHover);
    }
  }, [isMobile]);

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <Header />
        </div>
        <Cover />
        <main className={styles.main}>
          <div className={styles.container}>
            <div className={styles.about}>
              <p>Новогодние проекты позволяют сотрудникам почувствовать реальную пользу от своей деятельности и вдохновиться на следующий год. Это отличная инвестиция в лояльность действующих работников и продвижение HR-бренда компании. В этой статье разберём, как сделать так, чтобы новогодние проекты действительно работали на благо компании.</p>
              <p className={styles.h3}>В конце статьи есть бонус: Готовая структура новогоднего проекта</p>
            </div>
            <div className={styles.row}>
              <div className={styles.col}>
                <SpyMenu />
              </div>
              <div className={styles.col}>
                <div className={styles.section} data-scrollspy-trigger='0'>
                  <p>Внутрикорпоративные коммуникации играют важную роль в формировании корпоративной культуры и повышении лояльности сотрудников. Один из наиболее эффективных инструментов в этом направлении — новогодний проект с итогами года. Однако многие компании недооценивают его потенциал, рассматривая такие проекты как «развлекалово» или «траты на ветер». Давайте разберёмся, почему так происходит.</p>
                </div>
                <div className={styles.section} data-scrollspy-trigger='1'>
                  <h2 className={styles.h2}>В чем проблема новогодних проектов?</h2>
                  <p>Чаще всего проблема не в целесообразности самих проектов, а в их реализации. Мы разберём основные ошибки, с которыми сталкивались наши клиенты до того, как обратились к нам:</p>
                  <div className={styles.collapses}>
                    <Collapse defaultStateOpen={true}>
                      <>Фокус на компании, а не на сотрудниках.</>
                      <>
                        <p>Часто в проектах говорится только о развитии компании, корпоративных достижениях и планах на будущее, но не о людях, которые принимали в них участие. Из-за этого работники не чувствуют свою значимость и не осознают свою роль в развитии компании.</p>
                        <h3 className={styles.h3}>Как лучше делать:</h3>
                        <p>Включайте в новогодние проекты истории сотрудников, их достижения и вклад в успех компании. Подчёркивайте значимость каждого работника и благодарите их за усилия. Это поможет повысить мотивацию и лояльность сотрудников.</p>
                      </>
                    </Collapse>
                    <Collapse>
                      <>Самопиар вместо честности и открытости.</>
                      <>
                        <p>В проектах принято говорить об успехах, но замалчивать неудачи. При этом сотрудники знают, с какими трудностями компания сталкивалась в течение года, и не понимают, почему про них не рассказывают.</p>
                        <h3 className={styles.h3}>Как лучше делать:</h3>
                        <p>Будьте открытыми и честными. Говорите не только о достижениях, но и о вызовах, с которыми столкнулась компания. Обсуждение проблем и способов их решения поможет создать атмосферу доверия и совместной работы.</p>
                      </>
                    </Collapse>
                    <Collapse>
                      <>Игнорирование потребностей сотрудников.</>
                      <>
                        <p>При подведении итогов ключевая роль отдаётся корпоративным целям, а потребности и проблемы сотрудников задвигаются на второй план, а иногда и вовсе игнорируются.</p>
                        <h3 className={styles.h3}>Как лучше делать:</h3>
                        <p>Говорите о том, какие цели были достигнуты благодаря усилиям конкретных людей. Признавайте и подчёркивайте вклад каждого работника в общий успех компании. Это поможет создать чувство признательности и значимости у сотрудников, а также повысит их мотивацию и лояльность.</p>
                      </>
                    </Collapse>
                    <Collapse>
                      <>Односторонняя коммуникация.</>
                      <>
                        <p>Новогодние проекты — это отличный повод собрать обратную связь и узнать, что волнует сотрудников. Но чаще всего коммуникация остаётся односторонней и мнение работников не учитывается.</p>
                        <h3 className={styles.h3}>Как лучше делать:</h3>
                        <p>Активно собирайте и учитывайте обратную связь от сотрудников. Организуйте анонимные опросы, чтобы узнать их мнение и предложения. Это уникальная возможность понять потребности коллектива и улучшить рабочие процессы.</p>
                      </>
                    </Collapse>
                  </div>

                </div>

                <div className={styles.section} data-scrollspy-trigger='2'>
                  <h2 className={styles.h2}>Как новогодний проект поможет вашей компании</h2>
                  <p>Мы выделили несколько аргументов в пользу новогодних проектов. Давайте вместе решим, согласны вы с ними или нет.</p>
                  <div className={styles.argument}>
                    <div className={styles.point}>Аргумент 01</div>
                    <p>Новогодний проект объединяет сотрудников вокруг ценностей и достижений компании, укрепляя корпоративную культуру.</p>
                    <div className={styles.point}>Суть</div>
                    <p>Когда мы рассказываем о вкладе сотрудников в успех компании, они осознают свою значимость и вклад в общее дело. Новогодний проект даёт возможность почувствовать себя важной частью компании, что позитивно сказывается на мотивации и лояльности.</p>
                    <div className={styles.point}>Пример</div>
                    <p>Интерактивное голосование, где сотрудники могут отмечать наиболее значимые достижения компании, лучшие команды или работников.</p>
                  </div>
                  <Question>
                    Согласны ли вы, что подведение итогов года укрепляет корпоративную культуру?
                  </Question>
                  <div className={styles.argument}>
                    <div className={styles.point}>Аргумент 02</div>
                    <p>Хорошо проработанный новогодний проект удержит ваших ценных сотрудников и послужит способом привлечения новых талантов.</p>
                    <div className={styles.point}>Суть</div>
                    <p>В новогоднем проекте вы можете отразить не только достижения, но и планы по развитию компании. Так сотрудники увидят, в какую сторону движется компания и как они могут поучаствовать в её дальнейших достижениях. </p>
                    <p>Это вдохновляет и заряжает желанием действовать. Также эту часть проекта можно использовать для привлечения потенциальных сотрудников, которые смогут сопоставить цели и миссию компании со своими устремлениями.</p>
                    <div className={styles.point}>Пример</div>
                    <p>Истории успеха от лица особо отличившихся сотрудников — они могут рассказать о своём пути в компании, достижениях и планах на будущее.</p>
                  </div>
                  <Question>
                    Считаете ли вы, что новогодние проекты помогают привлечь и удержать талантливых сотрудников?
                  </Question>
                  <div className={styles.argument}>
                    <div className={styles.point}>Аргумент 03</div>
                    <p>Новогодний проект поможет быть в контакте со своими сотрудниками и понять, что их волнует.</p>
                    <div className={styles.point}>Суть</div>
                    <p>Вы можете включить в подготовку к проекту анонимные опросы и голосование сотрудников. Это поможет выявить проблемные зоны, поднять насущные вопросы во время подведения итогов года и совместно с командой понять, как их решить. </p>
                    <p>Эти действия дадут сотрудникам понять, что вы заботитесь об их эмоциональном состоянии, что является ещё одним плюсом к лояльности работников и созданию позитивной атмосферы в компании.</p>
                    <div className={styles.point}>Пример</div>
                    <p>Анонимный опросник, где сотрудники смогут поделиться своими предложениями и пожеланиями.</p>
                  </div>
                  <Question>
                    Считаете ли вы важным регулярно собирать обратную связь от сотрудников?
                  </Question>
                  <div className={styles.argument}>
                    <div className={styles.point}>Аргумент 04</div>
                    <p>Когда руководство открыто делится как достижениями, так и сложностями, это значительно повышает доверие сотрудников.</p>
                    <div className={styles.point}>Суть</div>
                    <p>Ключ к атмосфере открытости — это честное признание как достижений, так и неудач. Так сотрудники понимают, что от них ничего не скрывают, и они могут доверять компании, не боясь, что в неподходящий момент их решат сократить или снизить зарплату. Это располагает к более расслабленной и дружелюбной обстановке.</p>
                    <div className={styles.point}>Пример</div>
                    <p>Доступный всем документ, где руководители могут поделиться выводами из итогов года и планами на будущее.</p>
                  </div>
                  <Question>
                    Согласны ли вы, что прозрачность и доверие важны для успешной работы компании?
                  </Question>
                  <div className={styles.argument}>
                    <div className={styles.point}>Аргумент 05</div>
                    <p>Глядя на позитивные итоги года, сотрудники чувствуют подъем сил и желание продуктивнее трудиться ради достижения лучших результатов.</p>
                    <div className={styles.point}>Суть</div>
                    <p>Чтобы сотрудники чувствовали мотивацию, нужно подчёркивать их заслуги и показывать, как конкретно они помогли компании. Осознание своего вклада в общий успех помогает работникам понять, что их усердная работа уже оценена по заслугам, а чем больше они будут трудиться — тем больше признания получат.</p>
                    <div className={styles.point}>Пример</div>
                    <p>Раздел в проекте с персональными достижениями каждого сотрудника и описанием его вклада в успех компании.</p>
                  </div>
                  <Question>
                    Считаете ли вы, что признание достижений повышает продуктивность сотрудников?
                  </Question>
                </div>

                <div className={styles.section} data-scrollspy-trigger='3'>
                  <h2 className={styles.h2}>Бонус: Структура новогоднего проекта</h2>
                  <p>В этом разделе мы расскажем, какие смысловые блоки сделают ваш новогодний проект успешным. Возьмите эту структуру за основу, и вы сможете создать по‑настоящему работающий проект.</p>
                  <div className={styles.table}>
                    <Table />
                  </div>
                  <p>Тональность текстов проекта должна быть мягкой и дружелюбной, делайте акцент на благодарности, поддержке сотрудников и мотивации. Для оценки эффективности проекта используйте следующие метрики:</p>
                  <div className={styles.list}>
                    <ItemList>
                      Количество посещений.
                    </ItemList>
                    <ItemList>
                      Длительность сессии.
                    </ItemList>
                    <ItemList>
                      Количество собранной обратной связи.
                    </ItemList>
                  </div>
                </div>

                <div className={styles.section} data-scrollspy-trigger='4'>
                  <h2 className={styles.h2}>Заключение</h2>
                  <p>Если вы хотите сделать новогодний проект не просто красивой традицией с подведением итогов года, а инструментом для повышения лояльности и сплочения команды, то нужно в первую очередь фокусироваться на потребностях своих сотрудников. </p>
                  <p>Грамотно спланированный и реализованный проект способен повысить продуктивность команды, получить ценную обратную связь, снизить текучку кадров и привлечь новые таланты.</p>
                  <p>Если вы хотите узнать, как организовать такой проект в своей компании, оставьте свои контакты, и мы пришлём вам примеры реализованных успешных проектов.</p>
                  <div className={styles.form}>
                    <Form />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.cooperate} ref={refCoop}>
            <div className={styles.point}>
              Сотрудничать
            </div>
            <div className={`${styles.cooperate__text} `}>У вас есть похожая задача? Напишите нам! Мы предложим решение и подберем референсы</div>
            <div className={styles.cooperate__btn} ref={refCoopBtn} onClick={() => updatePopupOpen(true)}>Написать</div>
          </div>
          <div className={styles.container}>
            <div className={styles.more}>
              <h2 className={styles.more__title}>
                <span>вам также</span> <span className={styles.more__line}></span> <span>понравится</span>

                <div className={styles.more__icon}>
                  <img src={`${path}/img/more-icon.svg`} alt="" />
                </div>
              </h2>
              <div className={styles.more__text}>За 12 лет работы агентства мы сделали более 350 коммуникационных проектов</div>
              <div className={styles.more__row}>
                <div className={styles.more__col}>
                  <a href='https://www.infografika.agency/blog/kak-pobudit-sotrudnikov-delitsya-svoimi-ideyami-i-sekonomit-na-etom-mnogo-deneg' className={styles.more__card}>
                    <div className={`${styles.more__card_img}`}>
                      <img src={`${path}/img/more-img-1.webp`} alt="" />
                    </div>
                    <div className={styles.more__card_body}>
                      <div className={styles.more__card_info}>
                        <div className={styles.more__card_title}>Как побудить сотрудников делиться своими идеями и сэкономить на этом много денег?</div>
                        <div className={styles.more__card_comp}>HR <span>(Вовлеченность) (Мотивация)</span></div>
                      </div>
                      <div className={styles.more__card_icon}>
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="25" cy="25" r="24" fill="black" stroke="black" strokeWidth="2" />
                          <path d="M18.632 13V15.244H32.184L13 34.472L14.672 36.144L33.9 16.96V30.512H36.144V13H18.632Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
                <div className={styles.more__col}>
                  <a href='https://www.infografika.agency/blog/kak-translirovat-cennosti' className={styles.more__card}>
                    <div className={`${styles.more__card_img}`}>
                      <img src={`${path}/img/more-img-2.webp`} alt="" />
                    </div>
                    <div className={styles.more__card_body}>
                      <div className={styles.more__card_info}>
                        <div className={styles.more__card_title}>Как транслировать корпоративные ценности, чтобы сотрудники начали следовать им на практике</div>
                        <div className={styles.more__card_comp}>HR <span>(Миссия) (HR-бренд) (Ценности)</span></div>
                      </div>
                      <div className={styles.more__card_icon}>
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="25" cy="25" r="24" fill="black" stroke="black" strokeWidth="2" />
                          <path d="M18.632 13V15.244H32.184L13 34.472L14.672 36.144L33.9 16.96V30.512H36.144V13H18.632Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
                <div className={styles.more__col}>
                  <a href='https://www.infografika.agency/blog/kak-sozdat-welcome-book-kotoryy-sotrudniki-zahotyat-prochitat' className={styles.more__card}>
                    <div className={`${styles.more__card_img}`}>
                      <img src={`${path}/img/more-img-3.webp`} alt="" />
                    </div>
                    <div className={styles.more__card_body}>
                      <div className={styles.more__card_info}>
                        <div className={styles.more__card_title}>Как создать welcome book, который сотрудники захотят прочитать?</div>
                        <div className={styles.more__card_comp}>HR <span> (Адаптация) (Обучение) (HR-бренд)</span></div>
                      </div>
                      <div className={styles.more__card_icon}>
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="25" cy="25" r="24" fill="black" stroke="black" strokeWidth="2" />
                          <path d="M18.632 13V15.244H32.184L13 34.472L14.672 36.144L33.9 16.96V30.512H36.144V13H18.632Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );

}

export default Main;
